














import { API_HOST, SHARE_HOST } from '@/graphql/request';
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue';
import VueGoodshareReddit from 'vue-goodshare/src/providers/Reddit.vue';
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    VueGoodshareFacebook,
    VueGoodshareTwitter,
    VueGoodshareReddit,
  },
})
export default class SocialMediaButtons extends Vue {
  @Prop({ required: true })
  public shareId!: string;

  public shareLink = `${SHARE_HOST}/showCampaign?id=${this.shareId}`;
  public facebookShareLink = `${SHARE_HOST}/campaign/${this.shareId}`;
  public mounted() {
    console.dir(this.facebookShareLink);
  }
}
